<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f"><a id="pvii"></a><span epub:type="pagebreak" id="pagevii" title="vii">Foreword</span></h2>
<p class="para">My father and I crofted in Smirisary at the same time as Margaret Leigh became a crofter in the 1940s. At that time there were four families working the land; they were hard but happy days. Many an hour I spent with Margaret, exchanging stories while herding cattle.</p>
<p class="para1">Margaret Leigh was the only crofter in Smirisary with a horse. To the great amusement of the older folk it would not always do as she wanted it to. However, it was a great help to us all when peat had to be brought home.</p>
<p class="para1">Margaret very quickly became part of the crofting community and was well thought of. It all seems such a long time ago!</p>
<p class="para1">I am 81 years old; I have seen many changes, not least of which is the end of the crofting community as I knew it.</p>
<div class="move">
<p class="parar">Katy Maclean <em>née</em> Gillies</p>
<p class="parar"><em>Gortean</em></p>
<p class="parar"><em>Smirisary</em></p>
<p class="parar"><em>1996</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?5bb774c4